'use client';

// Third Party Plugins
import React, { useState, useCallback, useEffect } from 'react';
import Link from 'next/link';
// Types
import { ClientSideBooksWrapperProps } from './types';
// Utilities
import { filterBooks } from './utils/searchBooks'; // Import the filter utility
// Custom Components
import SearchForm from '../SearchForm';
import BookList from '../BookList';
import ImageContainer from '@/components/images/ImageContainer';
import LayoutContainer from '@/components/ui/LayoutContainer';
import ContentBlock from '@/components/blocks/ContentBlock';
import Logo from '@/components/images/Logo';
import HeroHeading from '@/components/ui/HeroHeading';
import { Book } from '../../types';

const ClientSideBooksWrapper: React.FC<ClientSideBooksWrapperProps> = ({
  headingOne,
  subheading,
  pageImageBlock,
  booksManyBlock,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchMode, setSearchMode] = useState<'title' | 'subject' | 'author'>(
    'title',
  );
  const [isGrid, setIsGrid] = useState(true);
  // Show only the first 4 books by default
  const [books, setBooks] = useState<Book[]>(booksManyBlock.slice(0, 4));

  const searchBooks = useCallback(() => {
    // console.log('Before filtering:', booksManyBlock);
    if (!searchTerm.trim()) {
      // Show only the first 4 books if no search term is provided
      setBooks(booksManyBlock.slice(0, 4));
      return;
    }
    const filteredBooks = filterBooks(booksManyBlock, searchTerm, searchMode);
    setBooks(filteredBooks || []);
  }, [searchTerm, searchMode, booksManyBlock]);

  useEffect(() => {
    searchBooks();
  }, [searchTerm, searchBooks]);

  // const mappedGalleryImages = mapGalleryImages(galleryManyBlock || []);

  return (
    <>
      <HeroHeading>
        <Logo />
        <h1>{headingOne}</h1>
        <p>{subheading}</p>
        <p style={{ fontSize: `15px`, fontWeight: 100, lineHeight: '1.5em' }}>
          The Animation Book Database lists animation books recommended by
          teachers and professionals in the animation community. Inclusion in
          the database does not imply endorsement, and exclusion does not
          indicate disapproval. The database will continue to grow with new
          recommendations from the animation education community. To suggest a
          book for inclusion, please use the{' '}
          <Link href="#suggest-a-book" style={{ color: `var(--c-yellow-2)` }}>
            Suggest A Book
          </Link>{' '}
          button at the bottom of this page.
        </p>
        {pageImageBlock ? (
          <ImageContainer
            image={pageImageBlock.asset.url}
            width={751}
            height={194}
            type="dynamic"
            alt={pageImageBlock.alt || ''}
          />
        ) : null}
        <SearchForm
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchMode={searchMode}
          setSearchMode={setSearchMode}
          isGrid={isGrid}
          setIsGrid={setIsGrid}
        />
      </HeroHeading>
      <LayoutContainer hasSectionGaps>
        <BookList books={books} isGrid={isGrid} />
        {/* {hasGallery && galleryManyBlock ? ( */}
        {/*   <Gallery images={mappedGalleryImages} /> */}
        {/* ) : null} */}
        <ContentBlock
          showCallToAction={true}
          callToActionLink="/contact?source=add-book"
          callToActionType="internal"
          callToActionTitle="Suggest a Book"
        >
          <div
            id="suggest-a-book"
            style={{ fontWeight: `bold`, fontSize: `18px` }}
          >
            If you have a book you would like to suggest please click on the
            button below:
          </div>
        </ContentBlock>
      </LayoutContainer>
    </>
  );
};

export default ClientSideBooksWrapper;
